import { useCallback } from 'react';
import { useParams } from 'react-router';
import { EmployeeService } from 'src/api/EmployeeService';
import type { Employee } from 'src/api/EmployeeService';
import { invalidateEmployee, invalidateEmployees } from '@stores/employeeStore';

type UpdateEmployee = (
    employeeId: string,
    employee: Partial<Employee>,
) => Promise<Employee | undefined>;

const useUpdateEmployee = (): { updateEmployee: UpdateEmployee } => {
    const { departmentId } = useParams<{
        departmentId: string;
    }>();

    const updateEmployee = useCallback<UpdateEmployee>(
        async (employeeId, employee) => {
            if (!departmentId) {
                throw new Error(
                    'useUpdateEmployee requires a departmentId route param',
                );
            }

            const updatedEmployee = await EmployeeService.updateEmployee(
                departmentId,
                employeeId,
                employee,
            );

            if (!updatedEmployee) {
                return undefined;
            }

            invalidateEmployee(departmentId, employeeId);
            invalidateEmployees(departmentId);

            return updatedEmployee;
        },
        [departmentId],
    );

    return { updateEmployee };
};

export default useUpdateEmployee;
